import {combineReducers} from 'redux';
import {resettableReducer} from 'reduxsauce';
import configureStore from './CreateStore';
import rootSaga from '../sagas/';

// listen for the action type of 'RESET', you can change this.
const resettable = resettableReducer('RESET');

/* ------------- Assemble The Reducers ------------- */
export const reducers = combineReducers({
  language: resettable(require('./LanguageRedux').reducer),
  messages: resettable(require('./MessagesRedux').reducer),
  auth: resettable(require('./AuthRedux').reducer),
  userProfile: resettable(require('./UserProfileRedux').reducer),

  dictionaries: resettable(require('./DictionariesRedux').reducer),

  search: resettable(require('./SearchRedux').reducer),

  diagnostic: resettable(require('./DiagnosticRedux').reducer),

  dealers: resettable(require('./DealersRedux').reducer),
  dealer: resettable(require('./DealerRedux').reducer),

  users: resettable(require('./UsersRedux').reducer),
  user: resettable(require('./UserRedux').reducer),

  reports: resettable(require('./ReportsRedux').reducer),
  report: resettable(require('./ReportRedux').reducer),

  notifications: resettable(require('./NotificationsRedux').reducer),
  notification: resettable(require('./NotificationRedux').reducer),

  clients: resettable(require('./ClientsRedux').reducer),
  client: resettable(require('./ClientRedux').reducer),

  billing: resettable(require('./BillingRedux').reducer),

  cars: resettable(require('./CarsRedux').reducer),
  carErrors: resettable(require('./CarErrorsRedux').reducer),

  carFirmwares: resettable(require('./CarFirmwaresRedux').reducer),
  fotaCar: resettable(require('./FotaCarRedux').reducer),

  firmwares: resettable(require('./FirmwaresRedux').reducer),
  firmware: resettable(require('./FirmwareRedux').reducer),

  campaigns: resettable(require('./CampaignsRedux').reducer),
  campaign: resettable(require('./CampaignRedux').reducer),
});

export default () => {
  const finalReducers = reducers;

  let {store, sagasManager, sagaMiddleware} = configureStore(
    finalReducers,
    rootSaga
  );

  if (module.hot) {
    module.hot.accept(() => {
      const nextRootReducer = require('./').reducers;
      store.replaceReducer(nextRootReducer);

      const newYieldedSagas = require('../sagas').default;
      sagasManager.cancel();
      sagasManager.done.then(() => {
        sagasManager = sagaMiddleware.run(newYieldedSagas);
      });
    });
  }

  return store;
};
